/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import type { Provider, TransactionRequest } from '@ethersproject/providers'
import type { PromiseOrValue } from '../../common'
import type { GobblerReserve, GobblerReserveInterface } from '../../art-gobblers/GobblerReserve'

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ArtGobblers',
        name: '_artGobblers',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    inputs: [],
    name: 'artGobblers',
    outputs: [
      {
        internalType: 'contract ArtGobblers',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]

const _bytecode =
  '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'

type GobblerReserveConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: GobblerReserveConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1

export class GobblerReserve__factory extends ContractFactory {
  constructor(...args: GobblerReserveConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      super(_abi, _bytecode, args[0])
    }
  }

  override deploy(
    _artGobblers: PromiseOrValue<string>,
    _owner: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<GobblerReserve> {
    return super.deploy(_artGobblers, _owner, overrides || {}) as Promise<GobblerReserve>
  }
  override getDeployTransaction(
    _artGobblers: PromiseOrValue<string>,
    _owner: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_artGobblers, _owner, overrides || {})
  }
  override attach(address: string): GobblerReserve {
    return super.attach(address) as GobblerReserve
  }
  override connect(signer: Signer): GobblerReserve__factory {
    return super.connect(signer) as GobblerReserve__factory
  }

  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): GobblerReserveInterface {
    return new utils.Interface(_abi) as GobblerReserveInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): GobblerReserve {
    return new Contract(address, _abi, signerOrProvider) as GobblerReserve
  }
}
